import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { deleteSurchargeRelation } from 'RestAPIs/admin';

import { GridRowId } from '@mui/x-data-grid-pro';

import { showSnackbar } from 'components/shared';

const useDelete = () => {
  const { t } = useTranslation('common');
  const queryClient = useQueryClient();
  const { mutate } = useMutation(
    (id: GridRowId[]) => deleteSurchargeRelation(id),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: ['surchargeRelations', 'list']
        });
        showSnackbar({ severity: 'success', message: t('deleteSuccessfully') });
      },
      onError: () =>
        showSnackbar({ severity: 'error', message: t('deleteWithErrors') })
    }
  );
  return { mutate };
};

export default useDelete;
